// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const GitIntegrationPlatformSchema = z.enum(['GITHUB','GITLAB','GITHUB_ENTERPRISE','GITLAB_SELF_HOSTED','AZURE_DEVOPS','GITFARM_AWS','ZIP_UPLOAD','BITBUCKET'] as const);

export type GitIntegrationPlatformType = `${z.infer<typeof GitIntegrationPlatformSchema>}`

export default GitIntegrationPlatformSchema;
